const FULL_TIME_JOB_TYPE = "fullTime";
const PART_TIME_JOB_TYPE = "partTime";
// const FULL_PART_TIME_JOB_TYPE = "fullPartTime";
const CONTRACT_JOB_TYPE = "contract";
const INTERNSHIP_JOB_TYPE = "internship";
const TEMP_JOB_TYPE = "temp";

const FULL_TIME_JOB_TYPE_TEXT = "Full-time";
const PART_TIME_JOB_TYPE_TEXT = "Part-time";
// const FULL_PART_TIME_JOB_TEXT = "Full-time / Part-time";
const CONTRACT_JOB_TYPE_TEXT = "Contract";
const INTERNSHIP_JOB_TYPE_TEXT = "Internship / placement";
const TEMP_JOB_TYPE_TEXT = "Temporary";

// mirror on server
const jobTypeLookup = {
  fullTime: FULL_TIME_JOB_TYPE_TEXT,
  partTime: PART_TIME_JOB_TYPE_TEXT,
  // fullPartTime: FULL_PART_TIME_JOB_TEXT,
  contract: CONTRACT_JOB_TYPE_TEXT,
  internship: INTERNSHIP_JOB_TYPE_TEXT,
  temp: TEMP_JOB_TYPE_TEXT,
};

export function getJobType(jobType) {
  return jobTypeLookup[jobType] || jobType;
}

export function getMarkerColourBasedOnJobType(jobType) {
  let markerColour = "red";
  if (jobType === FULL_TIME_JOB_TYPE) {
    markerColour = "green";
  } else if (jobType === PART_TIME_JOB_TYPE) {
    markerColour = "purple";
  } else if (jobType === CONTRACT_JOB_TYPE) {
    markerColour = "orange";
  }
  return markerColour;
}

export const DROP_DOWN_JOB_TYPE_OPTIONS = [
  {
    key: 1,
    text: getJobType(FULL_TIME_JOB_TYPE),
    value: FULL_TIME_JOB_TYPE,
    // selected: false,
    // active: false
  },
  { key: 2, text: getJobType(PART_TIME_JOB_TYPE), value: PART_TIME_JOB_TYPE },
  // {
  //   key: 3,
  //   text: getJobType(FULL_PART_TIME_JOB_TYPE),
  //   value: FULL_PART_TIME_JOB_TYPE,
  // },
  { key: 3, text: getJobType(TEMP_JOB_TYPE), value: TEMP_JOB_TYPE },
  { key: 4, text: getJobType(CONTRACT_JOB_TYPE), value: CONTRACT_JOB_TYPE },
  { key: 5, text: getJobType(INTERNSHIP_JOB_TYPE), value: INTERNSHIP_JOB_TYPE },
];
